import { useState, useEffect, useContext, createContext } from "react";
import axios from "axios";

const AuthContext = createContext();
const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    user: null,
    token: "",
    role: null,
  });

  // Update axios headers whenever auth token changes
  useEffect(() => {
    if (auth && auth.token) {
      const bearerToken = `Bearer ${auth.token}`;
      axios.defaults.headers.common["Authorization"] = bearerToken;
    } else {
      axios.defaults.headers.common["Authorization"] = "";
    }
  }, [auth && auth.token]);

  useEffect(() => {
    const data = localStorage.getItem("auth");
    if (data) {
      const parseData = JSON.parse(data);
      setAuth({
        ...auth,
        user: parseData.data.email,
        token: parseData.token,
        role: parseData.data.role || null,
      });
    }
  },[]);
  
  return (
    <AuthContext.Provider value={[auth, setAuth]}>
      {children}
    </AuthContext.Provider>
  );
};

// custom hook
const useAuth = () => useContext(AuthContext);

export { useAuth, AuthProvider };